<template>
  <div
    :class="$style['box']"
  >
    <div class="text-center mt-20 mb-10 sm:mb-20 font-bold font-audi-type-extendedbold px-12">
      <h1
        class="leading-tight"
        :class="$style['title']"
      >
        Ponte al volante de la gama e-tron
      </h1>
      <span
        class="font-audi-type-widelight"
        :class="$style['color-dark-grey']"
      >La oportunidad de conducir el nuevo Audi Q6 e-tron o Audi S6 e-tron en un entorno único</span>
    </div>

    <div
      class="w-full p-12"
      :class="$style['color-background-light-grey']"
    >
      <div class="block sm:flex sm:flex-row">
        <div class="w-full sm:w-3/5">
          <img
            src="@/assets/images/audi_image5.png"
            class="w-full block"
          >
        </div>
        <div class="w-full sm:w-2/5 p-5 sm:p-10 py-10 sm:pt-20">
          <h2
            class="font-audi-type-extendedbold text-2xl mb-5"
            :class="$style['color-dark-grey']"
          >
            Una nueva forma de movilidad
          </h2>
          <span
            class="font-audi-type-normal text-base"
            :class="$style['color-dark-grey']"
          >Atrévete con el nuevo Audi Q6 e-tron o Audi S6 e-tron y vive una experiencia de conducción única en nuestros test drive en las estaciones de esquí de Baqueira y Sierra Nevada.</span>
        </div>
      </div>
    </div>

    <div class="w-full p-12 pt-24">
      <div class="block sm:flex sm:flex-row">
        <div class="w-full sm:w-1/2 sm:pr-5">
          <img
            src="@/assets/images/audi_image6.png"
            class="w-full block mb-10"
          >

          <h2
            class="font-audi-type-extendedbold text-2xl mb-5"
            :class="$style['color-dark-grey']"
          >
            Baqueira Beret
          </h2>
          <span
            class="font-audi-type-normal text-base"
            :class="$style['color-dark-grey']"
          >Descubre la movilidad eléctrica y la tecnología quattro en el territorio quattro por excelencia. Te encontrarás con nuestros expertos en el lobby del Hotel Val de Neu 5*, donde el coche que elijas te irá a buscar para comenzar la experiencia.</span>
        </div>
        <div class="w-full sm:w-1/2 sm:pl-5 mt-10 sm:mt-0">
          <img
            src="@/assets/images/audi_image7.png"
            class="w-full block mb-10"
          >
          <h2
            class="font-audi-type-extendedbold text-2xl mb-5"
            :class="$style['color-dark-grey']"
          >
            Sierra Nevada
          </h2>
          <span
            class="font-audi-type-normal text-base"
            :class="$style['color-dark-grey']"
          >Sorpréndete con la tecnología del nuevo Audi Q6 e-tron en la estación de esquí más meridional de Europa. Nuestros expertos te recogerán en el Hotel Vincci Selección Rumaykiyya 5* para iniciar la experiencia de conducción en la que disfrutarás de la nueva electromovilidad de Audi.</span>
        </div>
      </div>
    </div>

    <div class="w-full p-12 pt-0">
      <div
        class="relative"
        :class="$style['background-image']"
        :style="{ backgroundImage: 'url('+ require('@/assets/images/audi_image8.png') +')' }"
      >
        <div
          class="w-5/5 sm:w-3/5 absolute pin-t pin-l mt-5 sm:mt-10 ml-5 sm:ml-10 mr-5 sm:mr-0 p-5 sm:p-10"
          :class="$style['white-background-text-box']"
        >
          <h2
            class="font-audi-type-extendedbold text-base sm:text-2xl mb-5"
            :class="$style['color-dark-grey']"
          >
            Ven a probar los nuevos<br>Audi Q6 e-tron o Audi S6 e-tron
          </h2>
          <span class="text-sm sm:text:base">Vive una experiencia de conducción durante 45 minutos junto a nuestro equipo de expertos en movilidad eléctrica.</span>
        </div>
      </div>
    </div>

    <div v-if="isMobile" />

    <div v-else />
  </div>
</template>

<script>

export default {
  components: {},

  props: {
    breakpoint: {
      type: Number,
      required: true
    }
  },

  computed: {
    isMobile () {
      return this.breakpoint < 672
    }
  }
}
</script>

<style
  lang="scss"
  module
>
.box {
  max-width: 1200px;
  padding: 150px 0px 50px 0;
  @apply mx-auto;
}

.color-dark-grey {
  color: #333333;
}

.color-background-light-grey {
  background-color: #E9EBEC;
}

.background-image {
  height: 500px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}

.white-background-text-box {
  background-color: white;
  opacity: 0.8;
}

.title {
  font-size: 36px;
  line-height: 36px;
  font-weight: 600;
  @apply font-audi-type-extendedbold;
  @apply mt-0;
  @apply mb-10;
  @apply color-dark-grey;
}

.text {
  @apply text-center;
  @apply font-audi-type-extendedbold;
  @apply font-bold;
  @apply px-10;

  font-size: 32px;
  line-height: 36px;
}

.description {
  font-size: 20px;
  line-height: 32px;
}

@media (min-width: 576px) {
  .text {
    font-size: 36px;
    line-height: 40px;
  }
}

@media (min-width: 768px) {
  .background-image {
    height: 600px;
  }

  .box {
    padding: 220px 0px 50px 0;
  }

  .text {
    font-size: 40px;
    line-height: 44px;
  }
}

@media (min-width: 960px) {
  .text {
    font-size: 44px;
    line-height: 50px;
  }
}
</style>
